import { PlayerDetailsClubMembershipPage } from './../player-club-membership/player-details-club-membership/player-details-club-membership.page';
import { HandicapHistoryPage } from './../handicap-history/handicap-history.page';
import { ChangePasswordPage } from './../change-password/change-password.page';
import { PlayerVoucherPage } from './../modal-screens/player-voucher/player-voucher.page';
import { PlayerHomeDataService } from './../../../redux/player-home/player-home-data-service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActionSheetController, AlertController, LoadingController, ModalController, NavParams, Platform, ToastController } from '@ionic/angular';
import { Observable, Subscription } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AddressData, ClubCredit, ClubHandicap, ClubInfo, ClubMembership, ClubMembershipExtended, DiscountCompanyPage, HandicapCalculation, HandicapSystem, UserAddress } from 'src/data/mygolf.data';
import { PlayerHomeInfo, PlayerInfo } from 'src/data/mygolf.data';
import { adjustViewZIndex } from 'src/globals';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { HandicapService } from 'src/providers/handicap-service/handicap-service';
import { SessionInfo } from 'src/data/authentication-info';
import { SessionActions, SessionDataService } from 'src/redux/session';
import { JsonService } from 'src/json-util';
import { PlayerHomeActions } from 'src/redux/player-home';
import { PerformanceClubListPage1 } from '../performance/club-list1/club-list1.page';
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { HandicapIndexSubscription } from 'src/data/premium-subscription';
import { FriendService } from 'src/providers/friend-service/friend-service';
import { ServerResult } from 'src/data/server-result';
import * as globals from 'src/globals';
import { isPresent } from 'src/providers/common-service';
import * as moment from 'moment';
import { PaymentService } from 'src/providers/payment-service/payment-service';
import { EditProfilePage } from '../edit-profile/edit-profile.page';
import { ProfileImageEditComponent } from '../edit-profile/profile-image-edit/profile-image-edit.component';
import { InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { PlayerService } from 'src/providers/player-service/player-service';
import { Location } from '@angular/common';
import { PlayerMg2uCreditsModal } from '../modal-screens/player-mg2u-credits/player-mg2u-credits.page';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { HandicapMembershipService } from 'src/providers/handicap-membership/handicap-membership.service';
import { ImageZoomPage } from '../modal-screens/image-zoom/image-zoom.page';
import { AccountOptionPage } from '../modal-screens/account-option/account-option.page';
import { CancelRequestComponent } from '../New Game/friend-list/cancel-request/cancel-request.component';
import { RejectRequestComponent } from '../New Game/friend-list/reject-request/reject-request.component';
import { UserListAddressPage } from '../user-profile/user-list-address/user-list-address.page';
import { ManageMembershipPageComponent } from './manage-membership-page/manage-membership-page.component';
import { ClubListPage } from '../normalgame/club-list/club-list.page';
import { PlayerAddClubMembershipPage } from '../player-club-membership/player-add-club-membership/player-add-club-membership.page';
import { PlayerSubscriptionPage } from '../modal-screens/player-subscription/player-subscription.page';
import { UserManageAddressPage } from '../user-profile/user-manage-address/user-manage-address.page';
import { TaxEinvoicingInfoPage } from './tax-einvoicing-info/tax-einvoicing-info.page';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {
  public type: string = 'playerProfile';
  public status: string = 'notFriend';
  playerHomeInfo$: Observable<PlayerHomeInfo>;
  public player$: Observable<PlayerInfo>;
  public memberships: Array<ClubMembership> = [];
  public clubIds: Array<number> = [];
  public statusGetHCP: boolean = false;
  public hasM2u: boolean = false;
  playerHcpSystem: string; //HandicapSystem;
  playerHandicapHistory: Array<HandicapCalculation>;
  public handicapHistory: HandicapCalculation;
  public clubHandicap: Array<ClubHandicap>;
  public playerClubHcp: any;
  handicapSystem: Array<HandicapSystem>;
  handicapIndex: number;
  public session: SessionInfo;
  totalClubCredits: number;
  playerCredits: Array<any>;
  appSettings: any;
  public hcpIdxSubs: HandicapIndexSubscription;
  playerPhoto$: Observable<string>;
  public requestByPlayer: boolean = true;
  public openedModal: boolean = false;
  navigationExtras: NavigationExtras = {};
  options: InAppBrowserOptions = {
    location: 'yes',//Or 'no'
    hidden: 'no', //Or  'yes'
    clearcache: 'yes',
    clearsessioncache: 'yes',
    zoom: 'yes',//Android only ,shows browser zoom controls
    hardwareback: 'yes',
    mediaPlaybackRequiresUserAction: 'no',
    shouldPauseOnSuspend: 'no', //Android only
    closebuttoncaption: 'Close', //iOS only
    disallowoverscroll: 'no', //iOS only
    toolbar: 'yes', //iOS only
    enableViewportScale: 'no', //iOS only
    allowInlineMediaPlayback: 'no',//iOS only
    presentationstyle: 'pagesheet',//iOS only
    fullscreen: 'yes',//Windows only
  };
  dataExtras: any;
  enableMGA: boolean = false;
  displayCountryNHSLogo: string = '';
  displayCountryNHSText: string = 'NHS'
  fromClub: boolean = false;
  appType: string;
  appFooterHide: boolean = false;
  userId: number;
  userAddressData: Array<UserAddress>;
  mode: string;
  save: boolean;
  iab: any;
  constructor(
    private loadingCtl: LoadingController,
    private playerHomeService: PlayerHomeDataService,
    private alertCtl: AlertController,
    private handicapService: HandicapService,
    private flightService: ClubFlightService,
    private modalCtl: ModalController,
    private playerService: PlayerService,
    private sessionActions: SessionActions,
    private playerHomeActions: PlayerHomeActions,
    private router: Router,
    private platform: Platform,
    private sessionService: SessionDataService,
    private keyboard: Keyboard,
    private toastCtl: ToastController,
    private friendService: FriendService,
    private paymentService: PaymentService,
    private actionSheetCtl: ActionSheetController,
    private actRoute: ActivatedRoute,
    // private iab: InAppBrowser,
    private navParams: NavParams,
    private Location: Location,
    private route: ActivatedRoute,
    private mg2uUtil: mygolfUtils,
    private hcpMemberService: HandicapMembershipService,

  ) {
    this.appSettings = this.mg2uUtil.getSettingsAttribute();

    if (this.router.getCurrentNavigation()) {
      if (this.router.getCurrentNavigation().extras.state) {
        this.dataExtras = this.router.getCurrentNavigation().extras.state;
      }
      else {
        this.router.navigate(['tabs/player-home'],{ replaceUrl: true });
        this.dataExtras = this.router.getCurrentNavigation().extras.queryParams.state;
      }

      this.status = this.dataExtras.status
      this.player$ = this.dataExtras.player;
      this.type = this.dataExtras.type;
      this.requestByPlayer = this.dataExtras.requestByPlayer ? this.dataExtras.requestByPlayer : true;
      this.openedModal = this.dataExtras.openedModal ? this.dataExtras.openedModal : false
      this.fromClub = this.dataExtras.fromClub
    }
    else {
      this.status = navParams.get('status');
      this.player$ = navParams.get('player');
      this.type = navParams.get('type');

      this.requestByPlayer = navParams.get('requestByPlayer') ? navParams.get('requestByPlayer') : true;
      this.openedModal = navParams.get('openedModal') ? navParams.get('openedModal') : false
      this.fromClub = navParams.get('fromClub');
    }


    if (!this.fromClub)
      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();

    if (!this.player$ && !this.fromClub) {
      this.player$ = this.playerHomeInfo$.pipe(map((playerHomeInfo: PlayerHomeInfo) => playerHomeInfo.player));

      // this.playerPhoto$ = this.playerHomeService.playerPhoto();

      this.playerPhoto$ = this.player$.pipe(map((playerInfo: PlayerInfo) => {
        if (playerInfo.photoUrl) {
          return playerInfo.photoUrl;
        } else if (!playerInfo.photoUrl && playerInfo.thumbnail) {
          return playerInfo.thumbnail;
        } else {
          return '';
        }
      }));

      console.debug("init player [0]", this.playerPhoto$, this.playerHomeService.playerPhoto())
    }
    else if (this.player$) {
      this.playerPhoto$ = this.player$.pipe(map(playerInfo => {
        // console.debug("init player profile : ", playerInfo)
        if (playerInfo.thumbnail)
          return playerInfo.thumbnail;
        else if (playerInfo.photoUrl)
          return playerInfo.photoUrl;
        else return ''
      }));
      console.debug("init player else", this.playerPhoto$)
    }

    if (this.type) {
      this.appFooterHide = true;
    }

    this.appType = globals.appType;
    this.enableMGA = this.mg2uUtil.isMGAEnable();

  }
  ngOnInit() {
    // adjustViewZIndex(this.nav, this.renderer); // rajiv
    if (this.type === 'playerProfile') {
      this._refreshMemberships();
    }
    this.getAppAttribute();
    this.getPlayerHandicapIndex();
  }
  ionViewWillEnter() {
    this.getPlayerCredits();
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      this.playerHcpSystem = player.defaultHandicapSystem
      // if(this.status === 'friend') {
      //   player.allowEdit = true
      // }
    });
  }
  ionViewDidEnter() {
    this.refreshProfile();
    this.getPlayerCredits();
    this.refreshHandicapSystem();
  }
  subHcpIdx: Subscription;
  subPlayerCredits: Subscription;
  ionViewWillLeave() {
    if(this.subHcpIdx) {
      this.subHcpIdx.unsubscribe();
      this.subHcpIdx = null;
    }
    if(this.subPlayerCredits) {
      this.subPlayerCredits.unsubscribe();
      this.subPlayerCredits = null;
    }
  }
  private _refreshMemberships(busy?: any) {
    if(1) return;
    if (!busy) {
      busy = this.loadingCtl.create({
cssClass: 'custom-loading',
        message: 'Please wait...',
        showBackdrop: false,
      });
    }
    this.playerService.getPlayerMemberships()
      .subscribe((memberships: Array<any>) => {
        if (memberships) {
          this.memberships = memberships;
          this.memberships.sort((a: ClubMembership, b: ClubMembership) => {
            if (a.homeClub) return -1;
            else if (b.homeClub) return 1;
            else return 0;
          })
          this.clubIds = [];
          memberships.forEach((m: ClubMembershipExtended) => {
            this.clubIds.push(m.club.clubId);
          });
          if (!busy) busy.dismiss().then(() => {
            this.refreshMygolfHandicap(busy);
          })
        }
        if (this.statusGetHCP) {
          MessageDisplayUtil.displayInfoAlert(this.alertCtl, 'Success',
            'Handicap updated', 'OK');
          this.statusGetHCP = false;
        }
      }, (error) => {
        if (busy) {
          this.loadingCtl.dismiss()
            .then(() => {
              if (error) {
                let msg = MessageDisplayUtil.getErrorMessage(error);
                MessageDisplayUtil.displayErrorAlert(this.alertCtl, 'Membership',
                  msg, 'OK');
              }
            })
        }
      }, () => {
        this._refreshHcpIdxSubscriptions(busy);
      });
  }
  async refreshMygolfHandicap(busy?: any) {
    let _player;
    if (!busy) {
      busy = await this.loadingCtl.create({
cssClass: 'custom-loading',
        message: 'Please wait...',
        showBackdrop: false,
      });
    }
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      this.playerHcpSystem = player.defaultHandicapSystem
      _player = player;
    });
    this.handicapService.getHandicapHistory(_player.playerId).pipe(map(res => {
      return res
    })).subscribe((data: Array<HandicapCalculation>) => {
      if (data.length > 0) {
        this.hasM2u = true;
        this.playerHandicapHistory = data;
        this.handicapHistory = data[0];
        this.handicapService.getClubHandicap(data[0].player.playerId).pipe(map(res => {
          return res;
        })).subscribe((data: Array<ClubHandicap>) => {
          this.clubHandicap = data;
          this.playerClubHcp = this.memberships;
          this.playerClubHcp.hcpDetail = [];
          if (data && data.length > 0) {
            this.memberships.forEach((m: ClubMembership) => {
              this.clubHandicap.forEach((ch: ClubHandicap) => {

                if (m.club.clubId === ch.clubInfo.clubId && ch.handicapSystem && ch.handicapSystem.id === this.playerHcpSystem) {
                  m.hcpDetail = ch
                } else if (m.club.clubId === ch.clubInfo.clubId && ch.handicapSystem && ch.handicapSystem.id.toLowerCase().includes('nhs')) {
                  m.nhsHcpDetail = ch;
                }
              })
              this.playerClubHcp.hcpDetail.push(m.hcpDetail);

            })
          }
        }, (error) => {
          if (busy) {
            this.loadingCtl.dismiss();
          }
        }, () => {
          if (busy) {
            this.loadingCtl.dismiss();
          }
        })
      }
    }, (error) => {
      this.handicapHistory = null; //new HandicapCalculation();
      this.hasM2u = false;
    }, () => {
      if (busy) {
        this.loadingCtl.dismiss();
      }
      this.refreshHandicapSystem();
    })
  }
  refreshHandicapSystem() {
    this.handicapSystem = [];

    let _player: PlayerInfo;
    let _forDate = moment().add(1, 'days').format('YYYY-MM-DD');
    this.player$.pipe(take(1))
      .subscribe(player => {
        _player = player;
      });
    this.flightService.getPlayerHandicapIndex(_player.playerId, _player.defaultHandicapSystem, _forDate)
      .subscribe((data: any) => {
        if (data) this.handicapIndex = data;
      });

    this.flightService.getHandicapSystemList()
      .subscribe((handicap: any) => {
        if (handicap && handicap.length > 0) {
          this.handicapSystem = handicap;
        }
      })
  }
  async openEditProfile() {
    let modal = await this.modalCtl.create({
      component: EditProfilePage,
      componentProps: {
        homeInfo: this.playerHomeInfo$,
        player: this.player$,
        type: this.type
      }
    });
    modal.onDidDismiss().then((data?: any) => {
      this.refreshProfile();
      setTimeout(() => {
        this.sessionService.getSession()
          .pipe(take(1))
          .subscribe((session: SessionInfo) => {
            this.session = session;
          })
      }, 100);

      setTimeout(() => {
        this.player$.pipe(filter(Boolean)).subscribe((player: PlayerInfo) => {
          this.session.countryId = player.countryId
          this.session.countryName = player.countryName;
          this.session.flagUrl = player.flagUrl;
          this.sessionActions.updatePreference(this.session);
        })
        this.getPlayerCredits();
      }, 500);
    });
    modal.present();
  }
  getPlayerCredits() {
    if(this.subPlayerCredits) return;
    if (this.fromClub) return;
    let _playerId;
    let _playerCountryId;
    this.player$.pipe(take(1))
      .subscribe(player => {
        _playerId = player.playerId;
        if (player.countryId) _playerCountryId = player.countryId
        else if (player.addressInfo) _playerCountryId = player.addressInfo.countryId;
      });
    this.totalClubCredits = 0;
    this.playerCredits = [];
    this.subPlayerCredits = this.flightService.getPlayerCredits(_playerId)
      .subscribe((data: any) => {
        if (data) {
          if (data && data.length > 0) {
            data.forEach((cc: ClubCredit) => {
              JsonService.deriveFulImageURL(cc.club, 'clubImage');
              JsonService.deriveFulImageURL(cc.club, 'clubLogo');
            })
            console.debug("get player credits : ", this.playerCredits, _playerCountryId)
            this.playerCredits = data
              .filter((a: ClubCredit) => {
                return a.club.address.countryData.id === _playerCountryId
              });
            if (this.playerCredits && this.playerCredits.length > 0) {
              this.totalClubCredits = this.playerCredits
                .map((a) => {
                  if (a) return a.balance + a.creditLimit
                  else return;
                }).reduce((a, b) => {
                  return a + b
                });

            }
          }
        }
      })
  }
  refreshProfile(enterPage?: boolean) {
    this.playerHomeActions.refreshForcefully();
    this._refreshMemberships();
    this.getPlayerCredits();


    if (!this.fromClub) {
      if (!enterPage) this.playerHomeActions.refreshForcefully();
      this._refreshMemberships();
    } else {
    }
    this.getPlayerCredits();
    this.getCountryNHSHcp();

    let _player;
    this.userAddressData = [];
    if (this.player$)
      this.player$.pipe(take(1))
        .subscribe((player: PlayerInfo) => {
          _player = JsonService.clone(player);
          this.userId = _player.userId;
          this.userAddressData = player.userAddresses; //JsonService.clone(_player.userAddresses);
          // console.debug("player info - user address : ", _player)
        });
  }
  goHome() {
    this.router.navigate(['player-home']);
  }
  close() {
    if (this.openedModal) {
      this.modalCtl.dismiss();
    } else {
      this.Location.back();
    }
  }
  async openAddClubMembership() {
    // this.nav.push(AddClubMembershipPage);
    let _excludedClubs = [];
    if (this.playerClubHcp && this.playerClubHcp.length > 0)
      this.playerClubHcp.forEach((pch) => {
        _excludedClubs.push(pch.club.clubId);
      })

    let modal = await this.modalCtl.create({
      component: ClubListPage,
      componentProps: {
        openedModal: true,
        forMembership: true,
        excludeClub: _excludedClubs,
      }
    })

    modal.onDidDismiss().then((data: any) => {
      let _clubMembership;
      if (data && (data.data.clubInfo || data.data.courseInfo)) {
        if (this.hasM2uHandicap()) {
          this.playerClubHcp.filter((clubMembership: ClubMembershipExtended) => {
            return clubMembership.club.id === data.data.clubInfo.clubId
          }).map((clubMembership) => {
            _clubMembership = clubMembership;
          });
        } else {
          this.memberships.filter((clubMembership: ClubMembershipExtended) => {
            return clubMembership.club.id === data.data.clubInfo.clubId
          }).map((clubMembership) => {
            _clubMembership = clubMembership;
          });
        }
        if (_clubMembership) {
          this._selectClubMembership(_clubMembership);
        } else this.openMembershipDetail(data.data.clubInfo);
      }
      if (this.platform.is('ios') && this.platform.is('capacitor')) {
        this.keyboard.hide();
      }
    });
    modal.present();
  }

  async openMembershipDetail(clubInfo: ClubInfo, editMode?: boolean) {
    let _editMode = editMode;
    let _player;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
    });
    let modal = await this.modalCtl.create({
      component: PlayerAddClubMembershipPage,
      componentProps: {
        clubInfo: clubInfo,
        player: this.player$,
        editMode: false
      }
    })


    modal.onDidDismiss().then((data: any) => {
      this._refreshMemberships();
      if (data && data.data.membership && !_editMode) {
        this._selectClubMembership(data.data.membership);
      }
    });
    modal.present();
  }


  _selectClubMembership(clubMembership: ClubMembershipExtended) {
    console.debug("selecting club membership : ", clubMembership)
    if (!clubMembership) {
      MessageDisplayUtil.showErrorToast("Please re-select club", this.platform, this.toastCtl,
        5000, "bottom");
      return false;
    }
  }

  async openMembershipOptions(club: ClubInfo, membershipNumber?: string, membership?: ClubMembershipExtended) {
    let _msg = "Enter your Membership Number and click Save";
    let _input = []
    let _buttons = [];
    let _txtCancel = 'Cancel';

    if (membership && membership.status.toLowerCase() === 'pending') {
      _input = [{
        name: 'title',
        placeholder: 'Membership Number',
        value: membershipNumber
      }]
      _buttons.push({
        text: _txtCancel,
        handler: data => {
          prompt.dismiss();
          if (this.platform.is('ios') && this.platform.is('cordova')) {
            this.keyboard.hide();
          }
          return false;
        }
      })
      _buttons.push({
        text: 'Save',
        handler: data => {
          prompt.dismiss()
            .then(() => {
              if (this.platform.is('ios') && this.platform.is('cordova')) {
                this.keyboard.hide();
              }
              if (data && data.title) {
                this._addMembership(club, data.title);
              }
            });
          return false;
        }
      })

    } else {
      _msg = 'Membership number : <br><b>' + membershipNumber + '</b><br>To change your Membership Number, please contact the club'
      _txtCancel = 'Close';
      _buttons.push({
        text: _txtCancel,
        handler: data => {
          prompt.dismiss();
          if (this.platform.is('ios') && this.platform.is('cordova')) {
            this.keyboard.hide();
          }
          return false;
        }
      })

    }

    let prompt = await this.alertCtl.create({
      header: 'Club Membership',
      message: _msg,
      inputs: _input,
      buttons: _buttons
    });
    prompt.present();

  }
  private _addMembership(club: ClubInfo, membership: string) {
    this.playerService.updateClubMembership(club.clubId, membership)
      .subscribe(() => {
        this._refreshMemberships();
      })
  }
  openPlayerFavouriteList() {
    // this.nav.push(FavouriteListPage);
    this.router.navigate(['player-favourite-list']);
  }
  async changePassword() {

    let _player;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
    });

    if (this.openedModal) {
      let modal = await this.modalCtl.create({
        component: ChangePasswordPage,
        componentProps: {
          openedModal: true,
          player: _player,
          fromClub: false

        },
        id: 'changePassword'
      })
      await modal.present();
    } else {
      let params: NavigationExtras = {
        state: {
          player: _player,
          fromClub: false
        }
      }
      this.router.navigate(['tabs/change-password'], params)
    }
  }
  onBackpage() {
    // this.Location.back();
    this.router.navigate(['tabs/player-home']);
  }
  async deleteMembership(membership: ClubMembershipExtended) {
    let confirm = await this.alertCtl.create({
      header: 'Delete Membership',
      message: 'Do you want to delete your membership details for ' +
        membership.club.clubName + '?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            confirm.dismiss();
            return false;
          }
        },
        {
          text: 'Delete',
          cssClass: 'delete-item',
          role: 'delete',
          handler: () => {
            confirm.dismiss()
              .then(() => {
                this._deleteClubMembership(membership);
              });
            return false;
          }
        }
      ]
    });
    confirm.present();
  }
  private _deleteClubMembership(membership: ClubMembership) {
    this.playerService.deleteClubMembership(membership.club.clubId)
      .subscribe(() => {
        MessageDisplayUtil.showMessageToast('Successfully removed club membership', this.platform, this.toastCtl, 3000, "bottom")
        this._refreshMemberships();
        return false;
      });
  }
  async editPhoto() {
    if (this.type === 'friendProfile') {
      let modal = await this.modalCtl.create({
        component: ProfileImageEditComponent,
        componentProps: {
          player: this.player$,
          friend: true
        }
      })
      modal.onDidDismiss().then(() => {
      });
      modal.present();
    }
    else if (this.type === 'viewProfile') {

      let _description = "";
      let _image: string;
      // this.playerPhoto$.map(image => image).subscribe((image)=>{
      //     _image = image;
      // });
      this.player$.subscribe((playerInfo) => {
        // .map((playerInfo)=>{
        if (playerInfo.photoUrl)
          _image = playerInfo.photoUrl;
        else if (playerInfo.thumbnail)
          _image = playerInfo.thumbnail;
        else _image = ''
      });

      setTimeout(async () => {
        let imageZoom = await this.modalCtl.create({
          component: ImageZoomPage,
          cssClass: 'self-adjustable-modal',
          componentProps: {
            image: _image,
            description: _description,
            descTopDown: 'top'
          }
          // image: _player && _player.image ? (_player.image?_player.image: _player.profile):''
        })
        imageZoom.present();
      }, 500)
    }

    else {
      let modal = await this.modalCtl.create({
        component: ProfileImageEditComponent,
        // cssClass: 'self-adjustable-modal',
        componentProps: {
          player: this.player$,
          friend: false
        }
      })
      modal.onDidDismiss().then((data: any) => {

        if (data && data.data && data.data.needRefresh) {
          this.playerHomeActions.setNeedRefresh(true);
          this.refreshProfile();
        }
      });
      modal.present();
    }
  }
  changeNHSPrompt() {
    this.player$.pipe(take(1))
      .pipe(map((playerInfo: PlayerInfo) => playerInfo.nhsNumber))
      .subscribe((nhsNumber) => {
        this._changeNHSPrompt(nhsNumber);
      });
  }
  private async _changeNHSPrompt(nhsNumber) {
    let prompt = await this.alertCtl.create({
      header: 'NHS Number',
      message: 'Enter the NHS Number and click Save',
      inputs: [
        {
          name: 'nhsNumber',
          placeholder: 'NHS Number',
          value: nhsNumber,
          type: 'text'

        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            prompt.dismiss().then(() => {
              if (this.platform.is('ios') && this.platform.is('capacitor')) {
                this.keyboard.hide();
              }
            });
            return false;
          }
        },
        {
          text: 'Save',
          handler: data => {
            prompt.dismiss().then(() => {
              if (data.nhsNumber === '') {
                if (this.platform.is('ios') && this.platform.is('capacitor')) {
                  this.keyboard.hide();
                }
              }
              else if (data.nhsNumber.length > 15) {
                if (this.platform.is('ios') && this.platform.is('capacitor')) {
                  this.keyboard.hide();
                }
                MessageDisplayUtil.displayErrorAlert(this.alertCtl, 'NHS Number',
                  'The NHS Number you entered is too long!', 'OK');
              }
              else if (data && data.nhsNumber !== nhsNumber) {
                this.playerService.updatePlayerNHS(data.nhsNumber)
                  .subscribe((resp: any) => {
                    this.playerHomeActions.setPlayerInfo('nhsNumber', data.nhsNumber);
                    // this.player.nhsNumber = data.nhsNumber;
                    if (this.platform.is('ios') && this.platform.is('capacitor')) {
                      this.keyboard.hide();
                    }
                    if (resp) {
                      this.getHandicapNHS();
                    }
                  }), (error) => {
                    // this.viewCtrl.dismiss({type: "acceptFriend"});
                    this.modalCtl.dismiss({ type: 'acceptFriend' });
                    let errorMsg = 'The NHS ' + nhsNumber + ' has already been used by existing player';
                    MessageDisplayUtil.displayErrorAlert(this.alertCtl, 'NHS Number', errorMsg, 'OK');
                  };
              }
            });
            return false;
          }
        }
      ]
    });
    prompt.present();
  }
  async getHandicapNHS() {
    let loader = await this.loadingCtl.create({
cssClass: 'custom-loading',
      message: 'Getting Handicap...',
      showBackdrop: false,
      // duration: 5000,
    });
    let _player: PlayerInfo;
    this.player$.pipe(take(1))
      .pipe(map((player: PlayerInfo) => player))
      .subscribe((player) => {
        _player = player
      });
    let _handicapSystem: Array<HandicapSystem>;
    _handicapSystem = this.handicapSystem.filter((hcp) => {
      return hcp.id.toLowerCase().includes('nhs')
    });
    loader.present().then(() => {
      this.flightService.syncPlayerHandicapIndex(_player.playerId, _handicapSystem[0].id)
        .subscribe((result) => {
          loader.dismiss().then(() => {
            this.statusGetHCP = true;
            this.refreshProfile();
          })
        }, (error) => {
          let _error = error;
          let _errorMessage;
          if (this.appAttribute && this.appAttribute.syncOverrideErrorMessage) {
            _errorMessage = this.appAttribute.syncErrorMessage
          } else if (this.appAttribute && !this.appAttribute.syncOverrideErrorMessage && _error && _error.errorMessage) {
            _errorMessage = _error.errorMessage
          } else _errorMessage = "MGA/NHS have blocked this feature. Please contact MGA for further assistance."

          MessageDisplayUtil.displayErrorAlert(this.alertCtl, 'Handicap Index',
            _errorMessage, 'OK');
          loader.dismiss();
          return;
        }, () => {
          loader.dismiss();
        })
    })
  }
  deriveClubHandicaps() {
    this.playerService.deriveClubHandicaps().pipe(map(res => { return res }))
      .subscribe((success: boolean) => {
        this.statusGetHCP = true;
        this.refreshProfile();
      }, (error) => {
        let msg = MessageDisplayUtil.getErrorMessage(error);
        if (msg == 'Error deriving the handicap index using NHS number') {
          msg = 'NHS number is not valid.'
        }
        MessageDisplayUtil.displayErrorAlert(this.alertCtl, 'Membership',
          msg, 'OK');
      }, () => {
        // MessageDisplayUtil.displayInfoAlert(this.alertCtl, "Success",
        //     "Handicap updated", "OK");
        // this._refreshMemberships();
      });
  }
  getFlagUrl(flagUrl: string) {
    if (flagUrl == null) { return null; }
    else {
      let flagIcon = flagUrl.split('/');
      return '/assets/img/flag/' + flagIcon[2];
    }
  }
  async promptSubscription() {
    let confirm = await this.alertCtl.create({
      header: 'Free Trial',//this.translation.translate("ScoringPage.GameFinishTitle"),
      message: 'You are entitled to subscribe for free 3-months trial',//this.translation.translate("ScoringPage.GameFinishMessage"),
      buttons: [
        {
          text: 'Not Now', //this.translation.translate("ScoringPage.GameFinishNo"),
          role: 'cancel',
          handler: () => {
            confirm.dismiss();
            return false;
          }
        },
        {
          text: 'Use Trial', //this.translation.translate("ScoringPage.GameFinishYes"),
          handler: () => {
            confirm.dismiss()
              .then(() => {
                this._requestTrialSubscripion();
              });
            return false;
          }
        }
      ]
    });
    confirm.present();
  }
  private async _requestTrialSubscripion(busy?: any) {
    if (!busy) {
      busy = await this.loadingCtl.create({
cssClass: 'custom-loading',
        message: 'Please wait...',
        showBackdrop: false,
        // dismissOnPageChange: false,
      });
    }
    // await busy.present().then(() => {
      this.playerService.requestTrialSubs().pipe(map(res => { return res }))
        .subscribe((data: HandicapIndexSubscription) => {
          // if (data.length > 0) {
          let hIS = data[0];
          //  setTimeout(() => {
          // this.hcpIdxSubs = data;
          //   }, 250);
          this.playerService.genHcpCalc()
            .subscribe((data: any) => {
              this.refreshProfile();
            })

          // }
          // busy.dismiss(memberships);
          setTimeout(() => {
            if (busy) {
              busy.dismiss().then(() => {
                MessageDisplayUtil.showMessageToast('Thank you for subscribing',
                  this.platform, this.toastCtl, 3000, 'bottom')

                // if(this.hcpIdxSubs)

              })
            }
          }, 450);

        }, (error) => {
          if (busy) {
            busy.dismiss().then(() => {
              if (error) {
                if(error?.message?.includes('unauthorized')) {
                } else {
                  let msg = MessageDisplayUtil.getErrorMessage(error);
                  MessageDisplayUtil.displayErrorAlert(this.alertCtl, 'Subscription',
                    msg, 'OK');

                }
              }

            })
          }

        }, () => {
          // if(busy) busy.dismiss().then();
          // this.playerHomeActions.refreshForcefully();
          // this._refreshMemberships();
        });
    // });
    // });
  }
  async setHomeClub(membership: ClubMembershipExtended) {
    let confirm = await this.alertCtl.create({
      header: 'Set Home Club',
      message: 'Do you want to set ' +
        membership.club.clubName + ' as your home club?',
      buttons: [
        {
          text: 'No',
          handler: () => {
            confirm.dismiss();
            return false;
          }
        },
        {
          text: 'Set Home',
          handler: () => {
            confirm.dismiss()
              .then(() => {
                this._setHomeclub(membership);
              });
            return false;
          }
        }
      ]
    });
    confirm.present();
  }
  private _setHomeclub(membership: ClubMembershipExtended) {
    this.playerService.updateClubMembership(membership.club.clubId,
      membership.membershipNumber, true)
      .subscribe(() => {
        this.mg2uUtil.setClubMembership(membership);
        this.mg2uUtil.setHomeClub(membership);
        this.refreshProfile();
      })
  }
  private getPlayerId() {
    return this.player$.pipe(take(1))
      .pipe(map((player: PlayerInfo) => player.playerId));
  }
  acceptFriend() {
    this.getPlayerId().subscribe((playerId: number) => {
      this.friendService.acceptFriendRequest(playerId)
        .subscribe((result: ServerResult) => {
          if (result.success) {
            this.playerHomeActions.refreshForcefully();
            // this.viewCtrl.dismiss({type: "acceptFriend"});
            this.modalCtl.dismiss({ type: 'acceptFriend' });
          }
        }, (error) => {
          this.modalCtl.dismiss({ type: 'acceptFriend' });
          // this.viewCtrl.dismiss({type: "acceptFriend"});
          globals.displayError(this.alertCtl, error, 'Accept Friend', 'OK');
        });
    });
  }
  requestFriend() {
    this.getPlayerId().subscribe(async (playerId: number) => {
      let busy = await this.loadingCtl.create({
cssClass: 'custom-loading',
        message: 'Please wait...',
      });
      // busy.present().then(() => {
        this.friendService.sendFriendRequest(playerId)
          .subscribe((result: ServerResult) => {
            if (busy) {
              busy.dismiss().then(() => {
                if (result.success) {
                  this.modalCtl.dismiss({ type: 'requestFriend' });
                }
              });
            }
          }, (error) => {
            if (busy) { }
            busy.dismiss().then(() => {
              this.modalCtl.dismiss();
              let msg = MessageDisplayUtil.getErrorMessage(error, 'Error creating friend request');
              MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 3000, 'bottom');
            });
          });
      // });
    });
  }
  async deleteFriendConfirm() {
    const modal = await this.modalCtl.create({
      component: RejectRequestComponent,
      mode: 'ios',
      cssClass: 'self-adjustable-modal',
      componentProps: {
        headerMessage: 'Remove Friend',
        message: 'Are you sure you want Remove this Friend?'
      }
    });

    await modal.present();
    await modal.present().then((data: any) => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });

    modal.onDidDismiss().then((data: any) => {
      if (data.data.isConfirm) {
        this.deleteFriend();
      }
    })
    // let deleteFriendConfirmation = await this.alertCtl.create({
    //   header: 'Remove Friend',
    //   message: 'Are you sure you want Remove this Friend?',
    //   buttons: [
    //     {
    //       text: 'Cancel',
    //       handler: () => {
    //         //
    //       }
    //     },
    //     {
    //       text: 'Yes',
    //       handler: () => {
    //         deleteFriendConfirmation.dismiss()
    //           .then(() => {
    //             this.deleteFriend();
    //           });
    //         return false;
    //       }
    //     }
    //   ]
    // });
    // deleteFriendConfirmation.present();
  }
  deleteFriend() {
    this.getPlayerId().subscribe((playerId: number) => {
      this.friendService.cancelFriendRequest(playerId)
        .subscribe(async (result: ServerResult) => {
          if (result.success) {
            let confirm = await this.alertCtl.create({
              header: 'Remove Friend',
              message: 'You have successfully remove friend',
              buttons: [
                {
                  text: 'OK',
                  handler: () => {
                    confirm.dismiss()
                      .then(() => {
                        // if (this.homeInfo) {
                        //     this.homeInfo.needRefresh = true;
                        // }
                        this.playerHomeActions.refreshForcefully();
                        this.modalCtl.dismiss({ type: 'deleteFriend' });
                      });
                    return false;
                  }
                }
              ]
            });
            confirm.present();
          }
        }, (error) => {
          this.modalCtl.dismiss();
          globals.displayError(this.alertCtl, error, 'Remove Friend', 'OK');
        });
    });
  }
  async deleteRequestConfirm() {
    const modal = await this.modalCtl.create({
      component: RejectRequestComponent,
      mode: 'ios',
      cssClass: 'self-adjustable-modal',
      componentProps: {
        headerMessage: 'Delete Request',
        message: 'Are you sure you want Remove this Friend Request?'
      }
    });

    await modal.present();
    await modal.present().then((data: any) => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });

    modal.onDidDismiss().then((data: any) => {
      if (data.data.isConfirm) {
        this.deleteRequest();
      }
    })
    // let confirm = await this.alertCtl.create({
    //   header: 'Delete Request',
    //   message: 'Are you sure you want Remove this Friend Request?',
    //   buttons: [
    //     {
    //       text: 'Cancel',
    //       handler: () => {
    //         //
    //       }
    //     },
    //     {
    //       text: 'Yes',
    //       handler: () => {
    //         confirm.dismiss()
    //           .then(() => {
    //             this.deleteRequest();
    //           });
    //         return false;
    //       }
    //     }
    //   ]
    // });
    // confirm.present();
  }
  deleteRequest() {
    this.getPlayerId().subscribe(async (playerId: number) => {
      let busy = await this.loadingCtl.create({
cssClass: 'custom-loading',
        message: 'Please wait...',
      });
      // busy.present().then(() => {
        this.friendService.cancelFriendRequest(playerId)
          .subscribe((result: ServerResult) => {
            if (busy) {
              busy.dismiss().then(() => {
                if (result.success) {
                  this.modalCtl.dismiss({ type: 'deleteRequest' });
                }
              });
            }
          }, (error) => {
            if (busy) {
              busy.dismiss().then(() => {
                this.modalCtl.dismiss();
                let msg = MessageDisplayUtil.getErrorMessage(error, 'Error deleting request');
                MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 3000, 'bottom');
              });
            }
          });
      // });
    });
  }
  getHandicap() {
    this.player$.pipe(take(1))
      .pipe(map((player: PlayerInfo) => player.nhsNumber))
      .subscribe((nhsNumber) => {
        this._getHandicap(nhsNumber);
      });
  }
  private async _getHandicap(nhsNumber) {
    if (!isPresent(nhsNumber) || nhsNumber == '') {
      let msg = 'Your NHS Number is blank';
      // globals.displayError(this.nav, msg, "Handicap Index", "OK");
      MessageDisplayUtil.displayErrorAlert(this.alertCtl, 'Handicap Index',
        msg, 'OK');
      //
      return;
    }
    let confirm = await this.alertCtl.create({
      header: 'Get Handicap',
      message: 'This will retrieve your NHS handicap index and calculate the handicap for each club you are a member of. Would you like to continue?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            confirm.dismiss();
            return false;
          }
        },
        {
          text: 'Yes',
          handler: () => {
            confirm.dismiss()
              .then(() => {
                //
                this.getHandicapNHS();
              });
            return false;
          }
        }
      ]
    });
    confirm.present();
  }
  public async openHcpHistory() {
    let hcpIdxSub: HandicapIndexSubscription; // = createHandicapIndexSubscription();
    hcpIdxSub = this.hcpIdxSubs
    if (this.type === 'friendProfile') {
      let modal = await this.modalCtl.create({
        component: HandicapHistoryPage,
        componentProps: { fromMenu: 'friend', player: this.player$, isModalOpen: true },
        id: 'handicapHistory'
      })
      await modal.present();
      // this.router.navigate(['handicap-history'], { queryParams: { fromMenu: 'friend', player: this.player$ } })
      return;
    }
    let _player;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
    });
    if (!this.handicapHistory && this.hcpIdxSubs && this.hcpIdxSubs.subscription) {
      MessageDisplayUtil.displayInfoAlert(this.alertCtl, 'Insufficient Scorecards', 'Please play more games to submit scorecards', 'OK');
      return;
    } else {
      if (this.hcpIdxSubs) {
        if (this.hcpIdxSubs.active) {
          let params: NavigationExtras = {
            state: {
              currentPlayer: _player,
              subsActive: true,
              player: _player,
            }
          }
          this.router.navigate(['handicap-history'], params)
        }

        else if (this.hcpIdxSubs.subscription && !this.hcpIdxSubs.active && (this.hcpIdxSubs.subscriptionType === 'T' || this.hcpIdxSubs.subscriptionType === 'P'))
          MessageDisplayUtil.displayErrorAlert(this.alertCtl, 'Subscription Expired', 'Please renew your subscription to view', 'OK');
        else {
          this.promptSubscription();//MessageDisplayUtil.displayErrorAlert(this.alertCtl, "Subscription Needed", "Please subscribe to view", "OK");
          //
        }
      } else {
        this.promptSubscription();  //MessageDisplayUtil.displayErrorAlert(this.alertCtl, "Subscription Needed", "Please subscribe to view", "OK");
        //
      }

    }



  }
  hasM2uHandicap(): boolean {
    // //
    return this.hasM2u;
  }
  private async _refreshHcpIdxSubscriptions(busy?: any) {
    if(this.subHcpIdx) return;
    if (!busy) {
      busy = await this.loadingCtl.create({
cssClass: 'custom-loading',
        message: 'Please wait...',
        showBackdrop: false,
      });
      //
    }
    this.subHcpIdx = this.playerService.getHcpIdxSubs()
      .subscribe((data: HandicapIndexSubscription) => {
        let hIS = data[0];
        this.hcpIdxSubs = data;
        //
        //
        if (busy) {
          this.loadingCtl.dismiss().then();
        }
      }, (error) => {
        let _error = error;
        if (busy) {
          this.loadingCtl.dismiss()
            .then(() => {
              //
              //
              if (error) {
                if(_error?.message?.includes('unauthorized')) {
                } else {
                  let msg = MessageDisplayUtil.getErrorMessage(_error.message);
                  MessageDisplayUtil.displayErrorAlert(this.alertCtl, 'Subscription',
                    msg, 'OK');
                }
              }
            })
        }
      });
  }
  public async openSubscription() {
    let _active = (this.hcpIdxSubs.active) ? `Yes` : `No`;
    let _subType = (this.hcpIdxSubs.subscriptionType === 'T') ? `Trial` : `Paid`;
    let _startDate: string = moment(this.hcpIdxSubs.startDate).format('MMM DD, YYYY');
    let _endDate: string = moment(this.hcpIdxSubs.endDate).format('MMM DD, YYYY');
    let msg = `<br>` + `Active : ` + _active +
      `<br> Type : ` + _subType +
      `<br>Start Date : ` + _startDate +
      `<br>End Date : ` + _endDate;
    let prompt = await this.alertCtl.create({
      header: 'Subscription Details',
      message: msg,
      buttons: [
        {
          text: 'Close',
          handler: data => {
            //
            prompt.dismiss().then(() => {
              if (this.platform.is('ios') && this.platform.is('capacitor')) {
                this.keyboard.hide();
              }
            });
            return false;
          }
        },
      ]
    });
    prompt.present();

  }
  async onRenewClick() {
    let modal = await this.modalCtl.create({
      component: PlayerSubscriptionPage,
      componentProps: {
        hcpIdxSubs: this.hcpIdxSubs,
        playerInfo: this.player$
      }
    })
    modal.onDidDismiss().then((data: any) => {
      //
      if (data) {
        //
        if (data.type === 'testCall') {
          this.testCall();
        } else if (data.type === 'getCollection') {
          this.getCollections()
        } else if (data.type === 'createCollection') {
          this.createCollection();
        } else if (data.type === 'getRemoteCollections') {
          this.getRemoteCollections();
        } else if (data.type === 'getLocalCollections') {
          this.getLocalCollections(data.collectionId);
        } else if (data.type === 'getBill') {
          this.getBill(data.billId);
        } else if (data.type === 'createBill') {
          this.createBill(data.collectionId);
        } else if (data.type === 'createRemoteBill') {
          this.createRemoteBill(data.collectionId);
        }
        // this.scorecard = data.scorecard
        // this._onCurrentHoleChange();
      }
    });
    modal.present();
  }
  testCall() {
    this.paymentService.testCall()
      .subscribe((data: any) => {
        //
      })
  }
  createCollection() {
    this.paymentService.createCollection()
      .subscribe((data: any) => {
        //
      })
  }
  getCollections() {
    // this.paymentService.getCollections()
    // .subscribe((data:any)=> {

    // });
    //
  }
  getRemoteCollections() {
    this.paymentService.getRemoteCollections()
      .subscribe((data: any) => {
        //
      })
  }
  getLocalCollections(collectionId?: string) {
    this.paymentService.getLocalCollections(collectionId)
      .subscribe((data: any) => {
        //
      })
  }
  getBill(billId?: string) {
    //
    this.paymentService.getBill(billId)
      .subscribe((data: any) => {
        //
      })
  }
  async createRemoteBill(collectionId?: string) {
    let loader = await this.loadingCtl.create({
cssClass: 'custom-loading',
      message: 'Procesing Payment...',
      showBackdrop: false
    });
    // loader.present().then(() => {
      this.paymentService.createRemoteBill(collectionId)
        .subscribe((data: any) => {
          loader.dismiss().then(() => {
            //
            if (data.url) {
              if (this.platform.is('capacitor')) {
                this.openWithInAppBrowser(data.url)
              } else {
                // this.openWithCordovaBrowser(data.url);
                window.open(data.url, '_self');

                // let modal = this.modalCtl.create(TestPaymentPage, {
                //     url: data.url
                //     // currentCourse   : c,
                //     // clubId          : this.scorecard.clubId,
                //     // scorecard       : this.scorecard,
                //     // editingScorecard: this.editingScorecard
                // });
                // modal.present();
              }

            }
          })

        }), (error) => {

        }, () => {

        }
    // })

  }
  async createBill(collectionId?: string) {
    //
    let loader = await this.loadingCtl.create({
cssClass: 'custom-loading',
      message: 'Procesing Payment...',
      showBackdrop: false
    });

    // loader.present().then(() => {
      this.paymentService.createBill(collectionId)
        .subscribe((data: any) => {
          loader.dismiss().then(() => {
            if (data.url) {
              if (this.platform.is('capacitor')) {
                this.openWithInAppBrowser(data.url)
              } else {
                // this.openWithCordovaBrowser(data.url);
                let win = window.open(data.url, '_system');
                win.onunload = function () {
                  //
                }
              }

            }
          })

        })
    // })


  }
  public openWithSystemBrowser(url: string) {
    let target = '_system';
    let browser = this.iab.create(url, target, this.options);
    MessageDisplayUtil.showMessageToast('Browser closed',
      this.platform, this.toastCtl, 3000, 'bottom')

    browser.on('exit').subscribe(() => {
      //
      MessageDisplayUtil.showMessageToast('exit Browser closed',
        this.platform, this.toastCtl, 3000, 'bottom')
    }, (err) => {
      if (err) { }
    });
    browser.close();
  }
  public openWithInAppBrowser(url: string) {
    let target = '_blank';
    let browser = this.iab.create(url, target, this.options);
    MessageDisplayUtil.showMessageToast('Browser closed',
      this.platform, this.toastCtl, 3000, 'bottom')

    browser.on('exit').subscribe(() => {
      MessageDisplayUtil.showMessageToast('exit Browser closed',
        this.platform, this.toastCtl, 3000, 'bottom')
      //
    }, (err) => {
      if (err) { }
    });
    // browser.close();
  }
  public openWithCordovaBrowser(url: string) {
    let target = '_self';
    let browser = this.iab.create(url, target, this.options);
    MessageDisplayUtil.showMessageToast('Browser closed',
      this.platform, this.toastCtl, 3000, 'bottom')

    browser.on('exit').subscribe(() => {
      MessageDisplayUtil.showMessageToast('exit Browser closed',
        this.platform, this.toastCtl, 3000, 'bottom')
      //
    }), (err) => {
      if (err) { }
    };
    browser.close();
  }
  async openPlayerVoucherList() {
    //
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      //
      _player = player
    });

    let modal = await this.modalCtl.create({
      component: PlayerVoucherPage,
      componentProps: {
        type: 'voucher',
        player: _player,
        forBooking: false,
        fromClub: false,
        who: 'player',
        showPlayerCard: true,
      }
    });
    modal.present();
    // this.navigationExtras.state = {
    //   type: 'voucher',
    //   player: _player,
    //   forBooking: false,
    //   fromClub: false,
    //   who: 'player',
    //   showPlayerCard: true,
    // }
    // this.router.navigate(['player-voucher'], this.navigationExtras)
  }
  async onMygolfCredit() {
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player
    });

    let params: NavigationExtras = {
      state: {
        player: _player
      }
    }
    this.router.navigate(['player-mg2u-credits'], params)
    // let modal = await this.modalCtl.create({
    //   component: PlayerMg2uCreditsModal,
    //   componentProps: {
    //     player: _player
    //   }
    // })
    // modal.present();
  }
  onHomeClick() {
    this.router.navigate(['player-home'])
  }
  onFAQClick() {
    this.router.navigate(['faq'])
  }
  getClubCreditsCurrency() {
    if (!this.playerCredits) return;
    let _playerId;
    let _playerCountryId;
    this.player$.pipe(take(1))
      .subscribe(player => {
        _playerId = player.playerId;
        _playerCountryId = player.countryId
        if (!player.countryId && (player.userAddresses && player.userAddresses.length > 0)) {
          _playerCountryId = player.userAddresses.filter((uad) => {
            return uad && uad.defaultAddress
          }).map((a) => {
            return a.address.countryData && a.address.countryData.id
          })
        }
      });

    let _currency = this.playerCredits.filter((a: ClubCredit) => {
      return a.club.address.countryData.id === _playerCountryId
    }).map((a) => {
      return a.currency.symbol;
    })
    return _currency[0];
  }
  onNotificationsClick() {
    this.router.navigate(['notifications'])
  }
  async onChangeDefaultHcpSystem() {
    if (!this.handicapSystem || (this.handicapSystem && this.handicapSystem.length === 0)) {
      this.refreshHandicapSystem();
      return;
    }
    let _buttons = [];
    _buttons.push({
      text: 'Set default Handicap System to'
    });
    let _handicapSystem = JsonService.clone(this.handicapSystem);
    let _player: PlayerInfo;
    this.player$.pipe(take(1))
      .subscribe(player => {
        _player = player;
      });
    _handicapSystem = _handicapSystem.filter((hcp) => {
      let _isPlayerDefault;
      if (hcp.id === _player.defaultHandicapSystem)
        _isPlayerDefault = true;
      return !_isPlayerDefault;
    })
    if (_handicapSystem && _handicapSystem.length > 0) {
      _handicapSystem.forEach((hcpSys: HandicapSystem) => {
        if (hcpSys.id && hcpSys.derivedByMygolf)
          _buttons.push({
            text: hcpSys.name + ' (' + hcpSys.shortCode + ')',
            handler: () => {
              // actionSheet.dismiss();
              this.updatePlayerDefaultHcp(hcpSys);
              // actionSheet.dismiss().then(()=>{
              //     this.updatePlayerDefaultHcp(hcpSys);
              // })
            }
          });
      })
    }
    _buttons.push({
      text: 'Cancel',
      role: 'cancel', // will always sort to be on the bottom
      icon: !this.platform.is('ios') ? 'close' : null,
      handler: () => {
        actionSheet.dismiss();
        return false;
      }
    })
    let actionSheet = await this.actionSheetCtl.create({
      buttons: _buttons
    });
    actionSheet.present();
  }
  async updatePlayerDefaultHcp(handicapSystem: HandicapSystem) {
    let _player: PlayerInfo;
    this.player$.pipe(take(1))
      .subscribe((player: PlayerInfo) => {
        _player = JsonService.clone(player);
        if (handicapSystem) player.defaultHandicapSystem = handicapSystem.id
      });
    let busy = await this.loadingCtl.create({
cssClass: 'custom-loading',
      message: 'Setting default handicap system...' + handicapSystem.id + ',' + _player
    });
    if (handicapSystem) _player.defaultHandicapSystem = handicapSystem.id
    this.playerHomeActions.updatePlayerProfile(_player, true)
      .subscribe((result: boolean) => {
        if (busy) {
          busy.dismiss().then(() => {
            // this.nav.pop();
            if (result) {
              //
              this.refreshProfile();
              // setTimeout(()=>{
              //     this.viewCtrl.dismiss();
              // },1000)
            }
          });
        }
      }, (error) => {
        if (busy) {
          busy.dismiss().then(() => {
            let msg = MessageDisplayUtil.getErrorMessage(error, 'Error setting default handicap system');
            MessageDisplayUtil.showErrorToast(msg, this.platform, this.toastCtl, 5000, 'bottom');
          })
        }
      })
  }
  getPlayerHcpSysDetail(handicapSystem) {
    if (!handicapSystem) return;
    if (!this.handicapSystem) return;
    if (this.handicapSystem && this.handicapSystem.length === 0) return '';
    let _hcpSystem: HandicapSystem;
    this.handicapSystem.filter((hcpSys) => {
      if (hcpSys.id === handicapSystem) {
        _hcpSystem = hcpSys;
        return true;
      } else return false;
    })
    return _hcpSystem.shortCode;
  }

  getPlayerNHS() {
    let _playerNHS;
    if (!this.playerHandicapHistory) return;
    if (this.playerHandicapHistory && this.playerHandicapHistory.length > 0) {
      _playerNHS = this.playerHandicapHistory.filter((data: HandicapCalculation) => {
        if (data && data.handicapSystem) {
          return data.handicapSystem.toLowerCase().includes('nhs');
        }
        else return false;
      })
    }
    if (_playerNHS && _playerNHS.length > 0) {
      return _playerNHS[0].handicapIndex
    }
    else return false;
  }
  getTotalClubCredits() {
    if (!this.totalClubCredits) return;
    if (this.totalClubCredits === 0) return 0;
    return this.mg2uUtil.numberWithCommas(this.totalClubCredits.toFixed(2));
  }

  onNewRoundClick() {

    let _clubInfo;
    this.router.navigate(['/course-lists']);
  }
  async getNHSReminder(event) {
    let _event = event.target as HTMLElement;

    if (_event.className !== 'input-wrapper') return;
    let _totalScorecards = 0;

    // _totalScorecards =
    this.playerHomeInfo$.pipe(take(1))
      .subscribe((playerHomeInfo: PlayerHomeInfo) => {
        _totalScorecards = playerHomeInfo.totalScoreCards
      });

    if (_totalScorecards > 3) return;

    let prompt = this.alertCtl.create({
      // title: 'Insufficient Scocards',
      header: 'Insufficient Scocards',
      message: 'Please submit at least 3 scorecards via the app in order to derive handicap. You can enter past or new games in New Game or click on \'Start New\'',
      buttons: [
        {
          text: 'Close',
          handler: async data => {
            (await prompt).dismiss().then(() => {
              if (this.platform.is('ios') && this.platform.is('capacitor')) {
                this.keyboard.hide();
              }
            });
            return false;
          }
        },
        {
          text: 'Start New',
          handler: ((data) => {
            this.onNewRoundClick();
            // this.onNormalGameScoringClick()
            // prompt.dismiss().then(()=>{
            //     this.onNormalGameScoringClick()
            // })
            // return false;
          })
        }
      ]
    });
    (await prompt).present();
  }

  async openHandicapMembership() {
    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player
    });
    let _playerId = _player.playerId | _player.id;
    let _params = {
      partnerId: null,
      programId: null,
      startDate: null,
      endDate: null,
      playerId: _playerId,
      approvedOrNot: true,
      pageSize: 30,
    }

    this.hcpMemberService.getMembershipApplications(_params)
      .then(async (result: any) => {

        if (result && result.status === 'success') {
          if (result && result.data && result.data.length > 1) {
            let modal = await this.modalCtl.create({
              component: PlayerVoucherPage,
              componentProps: {
                title: 'Handicap Membership',
                type: 'handicap',
                player: _player,
                player$: this.player$,
                forBooking: false,
                fromClub: false,
                who: 'player',
                showPlayerCard: true,
              }
            })
            modal.present();
          } else if (result && result.data && result.data.length === 1) {
            let modal = await this.modalCtl.create({
              component: PlayerVoucherPage,
              componentProps: {
                title: 'Handicap Membership',
                type: 'handicap',
                player: _player,
                player$: this.player$,
                forBooking: false,
                fromClub: false,
                who: 'player',
                showPlayerCard: true,
                application: result.data[0],
                newMode: true,
              }
            })
            modal.present();
          } else {
            let modal = await this.modalCtl.create({
              component: PlayerVoucherPage,
              componentProps: {
                title: 'Handicap Membership',
                type: 'handicap',
                player: _player,
                player$: this.player$,
                forBooking: false,
                fromClub: false,
                who: 'player',
                showPlayerCard: true,
                newMode: true
              }
            })
            modal.present();
          }
        }
      }).catch((error) => {

      })
  }

  getSettingsPage(attribute?: string, mode?: string) {
    let _show: boolean = false;
    let _enable: boolean = false;
    if (!attribute) return;

    // console.debug("get settings page : ", globals.clubId);
    if (globals.appType === 'club' && globals.clubId) {
      this.appSettings.clubSpecific.filter((c) => {
        return c.clubId === globals.clubId
      }).map((c) => {

        if (attribute === 'accountDelete') {
          _show = c.showSettings.accountDelete;
          _enable = c.enableSettings.accountDelete;
        }

      })
    } else {
      if (!this.appSettings) return;
      if (this.appSettings && !this.appSettings.main) return;
      if (attribute === 'accountDelete') {
        _show = this.appSettings.main.showSettings.accountDelete;
        _enable = this.appSettings.main.enableSettings.accountDelete;
      }
    }
    if (mode === 'enable') return !_enable;
    else if (mode === 'show') return _show;
  }

  async onClickUndoDeleteRequest() {
    let undoDeleteRequest = await this.alertCtl.create({
      header: 'Undo Delete Request',
      message: 'Are you sure you want to Undo Account Deletion?',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            // console.debug('Cancel clicked');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            undoDeleteRequest.dismiss()
              .then(() => {
                this.goUndoDeleteRequest();
              });
            return false;
          }
        }
      ]
    });
    undoDeleteRequest.present();
  }

  goUndoDeleteRequest() {
    this.flightService.userUndoDeleteRequest()
      .subscribe((data) => {
        if (data) {
          this.playerHomeActions.setNeedRefresh(true);
          this.refreshProfile();
        }
      })
  }

  async goClickAccountOption() {

    let modal = await this.modalCtl.create({
      component: AccountOptionPage,
      componentProps: {
        player: this.player$,
        friend: false
      }
    });
    modal.onDidDismiss().then((data: any) => {
      if (data && data?.data?.needRefresh) {
        this.playerHomeActions.setNeedRefresh(true);
        this.refreshProfile();
      }
    });
    modal.present();
  }

  async onClickNhsSetting() {
    let btns = [];
    if (this.enableMGA)
      btns.push({
        text: 'Subscription History',
        // icon   : !this.platform.is('ios') ? 'close' : null,
        handler: async () => {
          (await actionSheet).dismiss().then(() => {
            this.goHcpSubscriptionHistory();
            // return false;
          })
        }
      });
    btns.push({
      text: 'Edit',
      // icon   : !this.platform.is('ios') ? 'close' : null,
      handler: () => {
        // actionSheet.dismiss();
        this.changeNHSPrompt();
        return false;
      }
    });
    btns.push({
      text: 'Sync',
      // icon   : !this.platform.is('ios') ? 'close' : null,
      handler: () => {
        this.getHandicap();
        // actionSheet.dismiss();
        return false;
      }
    });
    let actionSheet = await this.actionSheetCtl.create({
      buttons: btns
    });
    actionSheet.present();
  }
  getCountryNHSHcp() {
    if (!this.player$) return;
    let _countryId = '';
    this.player$.pipe(filter(Boolean)).subscribe((player: PlayerInfo) => {
      _countryId = player.countryId;

      if (!_countryId && !player.userAddresses) return;
      if (!_countryId && player.userAddresses) {
        player.userAddresses.filter((uad) => {
          return uad.defaultAddress
        }).map((uad) => {
          if (uad.address.countryData)
            _countryId = uad.address.countryData.id;;
        })
      }

    })
    if (!_countryId) return;
    let _params = {
      country: _countryId,
      partnerServices: "NGA_MEMBERSHIP"
    }
    let _nhsPartner;
    this.hcpMemberService.getNHSHcp(_params)
      .then((result: any) => {
        let _partnerPage: DiscountCompanyPage
        if (result && result.status === 'success') {
          if (result.data) _partnerPage = result.data;
          if (_partnerPage) {
            if (_partnerPage.totalItems > 0) {
              _partnerPage.items.filter((p) => {
                return p.nationalGolfAssociation
              }).map((p) => {
                _nhsPartner = p;
              })
              if (_nhsPartner && _nhsPartner.id)
                this.displayCountryNHSText = _nhsPartner.id; //_partnerPage.items[0].id;
              if (_nhsPartner && _nhsPartner.partnerImage) this.displayCountryNHSLogo = _nhsPartner.partnerImage;//_partnerPage.items[0].partnerImage;
            }

          }

        }

      }, (error) => {


      })
  }
  async goHcpSubscriptionHistory() {

    let _player: PlayerInfo;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player
    });
    let _playerId = _player.playerId | _player.id;
    let modal = await this.modalCtl.create({
      component: PlayerVoucherPage,
      componentProps: {
        title: 'Handicap Membership',
        type: 'handicap',
        player: _player,
        player$: this.player$,
        forBooking: false,
        fromClub: false,
        who: 'player',
        showPlayerCard: true,
      }
    })
    modal.present();
    // this.nav.push(PlayerVoucherPage, {
    //     title: 'Handicap Membership',
    //     type: 'handicap',
    //     player: _player,
    //     player$: this.player$,
    //     forBooking: false,
    //     fromClub: false,
    //     who: 'player',
    //     showPlayerCard: true,
    // })
  }

  async openCancelModal() {
    const modal = await this.modalCtl.create({
      component: CancelRequestComponent,
      mode: 'ios',
      cssClass: 'self-adjustable-modal'
    });

    await modal.present();
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  async openRejectModal() {
    const modal = await this.modalCtl.create({
      component: RejectRequestComponent,
      mode: 'ios',
      cssClass: 'self-adjustable-modal',
      componentProps: {
        headerMessage: 'Request Reject',
        message: 'Are you sure you want to Remove this friend Request?'
      }
    });

    await modal.present();
    await modal.present().then(() => {
      const height = this.platform.height() - 250;
      document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
  }

  myCallbackFunction = function (_params) {
    console.debug("callback function ; ", _params);

    return new Promise((resolve, reject) => {

      resolve(() => {
        this.refreshProfile();
      });
    });
  }

  async manageAddress() {
    let _player;
    this.userAddressData = [];
    this.player$.pipe(take(1))
      .subscribe((player: PlayerInfo) => {
        _player = JsonService.clone(player);
        this.userId = _player.userId;
        this.userAddressData = player.userAddresses;
      });
    let modal = await this.modalCtl.create({
      component: UserListAddressPage,
      cssClass:'ion-infinite-scroll',
      mode: 'ios',
      componentProps: {
        userId: this.userId,
        player: this.player$,
        userAddressData: this.userAddressData,
        callback: this.myCallbackFunction
      }
    });
    modal.onDidDismiss().then((data: any) => {
      this.refreshProfile();
      if (!!data && data.data.mode === 'setDefault') {
        // this.playerHomeActions.setNeedRefresh(true);
        if (data.data.addressData) {
          this._setDefaultAddress(this.userId, data.data.addressData);
        }
        // this.refreshProfile();
      } else if (data && data.data.mode === "editAddress") {
        if (data.data.addressData) {
          let params: NavigationExtras = {
            state: {
              mode: data.mode,
              userId: this.userId,
              player: this.player$,
              userAddressData: data.addressData,
              callback: this.myCallbackFunction
            }
          }
          this.router.navigate(['user-manage-address'], params);
        }
      } else if (data && data.data.mode === "newAddress") {
        let params: NavigationExtras = {
          state: {
            mode: data.mode,
            userId: this.userId,
            player: this.player$,
            userAddressData: data.addressData,
            callback: this.myCallbackFunction
          }
        }
        this.router.navigate(['user-manage-address'], params);
      } else if (data && data.mode === "deleteAddress") {
        this.refreshProfile();
      }
    });
    await modal.present()
  }


  async openMembershipPage() {
    const modal = await this.modalCtl.create({
      component: ManageMembershipPageComponent,
      cssClass:'ion-infinite-scroll',
      mode: 'ios',
      componentProps: {
        player$: this.player$
      }
    });
    await modal.present();
  }
  async openNewMembershipPage() {
    const modal = await this.modalCtl.create({
      component: PlayerDetailsClubMembershipPage,
      mode: 'ios',
      componentProps: {
        player$: this.player$
      }
    });
    await modal.present();
  }

  appAttribute: any;
  getAppAttribute() {
    this.flightService.getAppAttributes()
      .subscribe((data: any) => {
        console.debug("[app attribute] : ", data)
        if (data) {
          data.filter((d) => {
            return d.page === 'externalNHS'
          }).map((d) => {
            this.appAttribute = d
          })

        }
      })
  }

  goPlayerClubMembership() {
    let params: NavigationExtras = {
      state: {
        player: this.player$
      }
    }
    this.router.navigate(['player-details-club-membership'], params)
  }

  testUserAddress() {
    console.table(this.player$);

    let _player;
    let _userId;
    let _addressData;
    let _addressName;

    this.player$.pipe(take(1))
      .subscribe((player: PlayerInfo) => {
        _player = JsonService.clone(player);
        _userId = _player.userId;
        this.userId = _player.userId;
        _player.userAddresses.filter((userAddress: UserAddress) => {
          return userAddress.defaultAddress
        }).map((userAddress: UserAddress) => {
          _addressData = userAddress.address
          _addressName = userAddress.name
        })
      });
    // console.log("user addresses : ", _addressData, _addressName, _userId, _player)
    this.flightService.userProfileUpdateDefaultAddress(_userId, _addressName, _addressData)
      .subscribe((data) => {
        console.log("calling update default address : ", data)
      })
  }

  getDefaultAddress() {
    let _addressData: AddressData;
    let _addressName;

    let _player;
    this.player$.pipe(take(1))
      .subscribe((player: PlayerInfo) => {
        _player = JsonService.clone(player);
        if (_player && _player.userAddresses) {
          _player.userAddresses.filter((userAddress: UserAddress) => {
            return userAddress.defaultAddress
          }).map((userAddress: UserAddress) => {
            _addressData = userAddress.address
            _addressName = userAddress.name
          })
        }
      });

    // console.debug("user address : ", _addressData)
    if (!_addressData || _addressData === undefined) return;
    let _fullAddress = [];

    let _country = '';
    // _address = _fullAddress?_fullAddress.join(','):'';
    _fullAddress.push(_addressName);
    _addressData.address1 ? _fullAddress.push(_addressData.address1) : null;
    _addressData.address2 ? _fullAddress.push(_addressData.address2) : null;
    _addressData.city ? _fullAddress.push(_addressData.city) : null;
    _addressData.postCode ? _fullAddress.push(_addressData.postCode) : null;
    _addressData.state ? _fullAddress.push(_addressData.state) : null;
    _addressData.countryData ? _fullAddress.push(_addressData.countryData.name) : null;
    _addressData.countryData ? _fullAddress.push(" (" + _addressData.countryData.id + ")") : null;


    // _fullAddress += _addressName + ' - ' + _addressData.address1 + ', ' + _addressData.address2 +
    // _addressData.city + ', ' + _addressData.postCode + ', ' + _addressData.state;
    if (_addressData.countryData) {
      // _fullAddress += ', ' + _addressData.countryData.name
      _country = " (" + _addressData.countryData.id + ")"
    }

    return _addressName + _country; //_fullAddress;
  }

  async goEditAddressPage() {
    // this.nav.push(UserListAddressPage);
    let _player;
    this.userAddressData = [];
    this.player$.pipe(take(1))
      .subscribe((player: PlayerInfo) => {
        _player = JsonService.clone(player);
        this.userId = _player.userId;
        this.userAddressData = player.userAddresses; //JsonService.clone(_player.userAddresses);
        // console.debug("player info - user address : ", _player)
      });
    // console.debug("calling modal user address : ", this.userAddressData)
    const modal = await this.modalCtl.create({
      component: UserListAddressPage,
      mode: 'ios',
      componentProps: {
        userId: this.userId,
        player: this.player$,
        userAddressData: this.userAddressData,
        callback: this.myCallbackFunction
      }
    });
    modal.onDidDismiss().then((data: any) => {
      // console.debug("dismiss user address : ", data)
      if (data && data.data.mode === 'setDefault') {
        // this.playerHomeActions.setNeedRefresh(true);
        if (data.data.addressData) {
          this._setDefaultAddress(this.userId, data.addressData);
        }
        // this.refreshProfile();
      } else if (data && data.data.mode === "editAddress") {
        if (data.addressData) {
          let params: NavigationExtras = {
            state: {
              mode: data.mode,
              userId: this.userId,
              player: this.player$,
              userAddressData: data.addressData,
              callback: this.myCallbackFunction
            }
          }
          this.router.navigate(['user-manage-address'], params)
        }
      } else if (data && data.mode === "newAddress") {
        let params: NavigationExtras = {
          state: {
            mode: data.mode,
            userId: this.userId,
            player: this.player$,
            userAddressData: data.addressData,
            callback: this.myCallbackFunction
          }
        }
        this.router.navigate(['user-manage-address'], params)
      } else if (data && data.mode === "deleteAddress") {
        this.refreshProfile();
      }
    });
    modal.present();
  }
  async createNewUsername() {
    let _username;
    let prompt = await this.alertCtl.create({
      header: 'Create Username',
      message: "Once you've created this username, you can either use this username or email to login",
      inputs: [
        {
          name: '_username',
          placeholder: 'Username',
          value: _username,
          type: 'text'
        },
      ],
      buttons: [
        {
          text: 'Not yet',
          handler: data => {
            console.log('Cancel clicked');
            prompt.dismiss().then(() => {
              if (this.platform.is('ios') && this.platform.is('cordova')) {
                this.keyboard.hide();
              }
            });
            return false;
          }
        },
        {
          text: 'Create',
          handler: data => {
            _username = data._username;
            console.log("username : ", data._username)
            if (data._username === null || data._username.length === 0) {
              MessageDisplayUtil.showErrorToast('Username can be in alphanumeric and not more than 30 characters.',
                this.platform, this.toastCtl, 3000, 'bottom');
              return;
            } else if (data._username.length > 30) {
              MessageDisplayUtil.showErrorToast('Username must not be more than 30 characters.',
                this.platform, this.toastCtl, 3000, 'bottom');
              return;
            }
            else if (!this.isAlphaNumeric(data._username)) {
              MessageDisplayUtil.showErrorToast('Username must be only alphanumeric and no spaces.',
                this.platform, this.toastCtl, 3000, 'bottom');
              return;
            }
            else {
              prompt.dismiss().then(() => {

              });
              return false;
            }
          }
        }
      ]
    });
    prompt.present();
  }

  isAlphaNumeric(str) {
    var code, i, len;

    for (i = 0, len = str.length; i < len; i++) {
      code = str.charCodeAt(i);
      if (!(code > 47 && code < 58) && // numeric (0-9)
        !(code > 64 && code < 91) && // upper alpha (A-Z)
        !(code > 96 && code < 123)) { // lower alpha (a-z)
        return false;
      }
    }
    return true;
  };

  _setDefaultAddress(userId, addressData) {
    let _userId = userId;
    let data = addressData.name;
    this.flightService.userProfileSetDefaultAddress(_userId, data)
      .subscribe((data: any) => {
        console.debug("set default address : ", data)
        if (data) {
          this.refreshProfile();
          MessageDisplayUtil.showMessageToast('Successfully set ' + data?.name + ' as default address',
            this.platform, this.toastCtl, 3000, 'bottom');
        }
      }, (error) => {
        MessageDisplayUtil.showErrorToast('Failed to set ' + data + ' as default address',
          this.platform, this.toastCtl, 3000, 'bottom');
      });

  }

  async onChangeDefaultAddress() {
    let _userAddressData = [];
    let _player;
    let _userId;
    this.userAddressData = [];
    this.player$.pipe(take(1))
      .subscribe((player: PlayerInfo) => {
        _player = JsonService.clone(player);
        _userId = _player.userId;
        this.userId = _player.userId;
        _userAddressData.push(..._player.userAddresses);
        this.userAddressData = JsonService.clone(_player.userAddresses);
      });
    let prompt = await this.alertCtl.create({
      header: 'Change default address',
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            console.log('Cancel clicked');
            prompt.dismiss().then(() => {
              if (this.platform.is('ios') && this.platform.is('cordova')) {
                this.keyboard.hide();
              }
            });
            return false;
          }
        },
        {
          text: 'Change',
          handler: ((data) => {
            console.log(data);
            prompt.dismiss().then(() => {
              this.flightService.userProfileSetDefaultAddress(_userId, data)
                .subscribe((data: any) => {
                  if (data) {
                    this.refreshProfile();
                    MessageDisplayUtil.showMessageToast('Successfully set ' + data?.name + ' as default address',
                      this.platform, this.toastCtl, 3000, 'bottom');
                  }
                }, (error) => {
                  MessageDisplayUtil.showErrorToast('Failed to set ' + data + ' as default address',
                    this.platform, this.toastCtl, 3000, 'bottom');

                })
            })
            return false;
          })
        }
      ]
    });
    let _input = []
    _userAddressData.forEach((uad: UserAddress) => {
      let _country = '';
      if (uad.address.countryData) _country = "(" + uad.address.countryData.id + ")"
      _input = [{
        type: 'radio',
        label: uad.name + _country,
        value: uad.name,
        checked: uad.defaultAddress ? true : false
      }]
      prompt.inputs = _input;
    })
    prompt.present();
  }


  async onZoomImage() {
    let _description = "";
    let _image = '';
    // _image =
    this.playerPhoto$.subscribe((photo)=>{
      console.debug("zoom image : ", photo)
      _image = photo
    })
    // _description = item.playerName? item.playerName : '';

    console.debug(" zoom image ", this.playerPhoto$)


    const modal: any = await this.modalCtl.create(
      {
        component: ImageZoomPage,
        cssClass: 'self-adjustable-modal',
        componentProps: {
          image: _image,
          description: _description,
          descTopDown: 'top'
        }
      });
    await modal.present();
  }

  onClickPhoto() {
    console.debug("click photo", this.type)
    if(this.type === 'playerProfile') {
      this.editPhoto();
    } else this.onZoomImage();
  }

  openPlayerEInvoicing() {
    this.getPlayerDetails()
    .then(async (result: any)=>{
      if(result) {
        console.debug("opening tax einvoice", result)
        let modal = await this.modalCtl.create({
          component: TaxEinvoicingInfoPage,
          componentProps: {
            openedModal: true,
            forMembership: true,
            playerData: result,
          }
        });
        modal.onDidDismiss().then((data: any) => {
        });
        modal.present();
      }
    })
  }

  getPlayerDetails() {
    return new Promise((resolve, reject) => {
    let _player;
    this.player$.pipe(take(1))
      .subscribe((player: PlayerInfo) => {
        _player = JsonService.clone(player);
        console.debug("loading player : ", _player)
      });

    this.flightService.getPlayerDetails(_player?.playerId)
    .subscribe((data)=>{
      if(data) {
        resolve(data)
      }
    })
    })
  }

  playerHcpIndexInfo: any;
  getPlayerHandicapIndex() {
    let _playerId;
    let _playerHcpSystem;
    this.player$.pipe(take(1))
      .subscribe(player => {
        _playerId = player.playerId;
        _playerHcpSystem = player.defaultHandicapSystem;
      });
    this.flightService.getPlayerHandicapIndexInfo(_playerId, _playerHcpSystem)
    .subscribe((data)=>{
      if(data) this.playerHcpIndexInfo = data;
    })
  }
}
